/*
  Heat filter.

  The masthead's MILD and SPICY halves link to ?heat=. Liquid cannot read a
  query parameter — there is no request.query object — so the filter is applied
  here instead. Without JS the page simply shows the whole range, which is a
  fine outcome rather than a broken one.
*/
(function () {
  'use strict';

  function apply() {
    var heat = new URLSearchParams(window.location.search).get('heat');
    var root = document.querySelector('.fl-shop');
    if (!root) return;

    var valid = heat === 'mild' || heat === 'spicy';
    root.querySelectorAll('.fl-shop__item').forEach(function (item) {
      item.hidden = valid && !item.classList.contains('fl-shop__item--' + heat);
    });

    // A group with nothing left in it is hidden too, and its count corrected.
    root.querySelectorAll('.fl-shop__group').forEach(function (group) {
      var shown = group.querySelectorAll('.fl-shop__item:not([hidden])').length;
      group.hidden = shown === 0;
      var count = group.querySelector('.fl-shop__group-count');
      if (count) count.textContent = String(shown);
    });

    var banner = root.querySelector('.fl-shop__filter');
    if (banner) banner.hidden = !valid;
    if (valid && banner) {
      var chip = banner.querySelector('.fl-shop__filter-chip');
      if (chip) {
        chip.textContent = heat;
        chip.className = 'fl-shop__filter-chip fl-shop__filter-chip--' + heat;
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
})();
